import React, {memo} from 'react';
import PropTypes from 'prop-types';
import FooterNav from './FooterNav';
import FooterBottom from './FooterBottom';
import './Footer.less';

function Footer({
  showFooterNav, showFooterBottom, isFull, className,
}) {
  return (
    <footer className={`footer ${isFull ? 'full' : ''} ${className}`}>
      {showFooterNav && <FooterNav />}
      {showFooterBottom && <FooterBottom />}
    </footer>
  );
}

Footer.defaultProps = {
  className: '',
  showFooterNav: true,
  showFooterBottom: true,
  isFull: false,
};

Footer.propTypes = {
  className: PropTypes.string,
  showFooterNav: PropTypes.bool,
  showFooterBottom: PropTypes.bool,
  isFull: PropTypes.bool,
};

export default memo(Footer);
